
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/buy-crypto",
      function () {
        return require("private-next-pages/personal/buy-crypto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/buy-crypto"])
      });
    }
  